module.exports = __webpack_public_path__ + "static/media/a8-logo.a498b3a5.svg";